export const colors = {
  white: '#FFFFFF',
  black: '#0A1629',

  // blue theme
  blue: '#00ADE7',
  lightBlue: '#B3E6F8',
  lightestBlue: '#F2FCFF',

  // red theme
  red: '#F41828',
  lightRed: '#FCBABF',
  lightestRed: '#FFF2F3',

  // orange theme
  orange: '#FF9000',
  lightOrange: '#FFE8CA',
  lightestOrange: '#FFF6EA',

  // green theme
  green: '#8ECE19',
  lightGreen: '#DDF0BA',
  lightestGreen: '#F4FAEB',

  // purple theme
  purple: '#6269C9',
  lightPurple: '#D0D2EF',
  lightestPurple: '#F4F6FF',

  // pink theme
  pink: '#F72585',
  lightPink: '#FDBEDA',
  lightestPink: '#FEE9F3',

  // rust theme
  rust: '#9B2226',
  lightRust: '#E1BDBE',
  lightestRust: '#FFF0F0',

  // shades of grey
  darkGrey: '#333333',
  grey: '#666666',
  lightGrey: '#9999',

  blueGrey: '#9497A5'
};

export const alpha = {
  tenPercent: 0.1,
  twentyPercent: 0.2,
  sixtyPercent: 0.6,
  seventyPercent: 0.7,
  eightyPercent: 0.8
};

const getRGBFromHex = (hex) => {
  const r = parseInt(hex?.slice(1, 3), 16);
  const g = parseInt(hex?.slice(3, 5), 16);
  const b = parseInt(hex?.slice(5, 7), 16);

  return [r, g, b];
};
export const hexToRgbA = (hex, alpha = null) => {
  const values = getRGBFromHex(hex);
  if (alpha !== null) {
    values.push(alpha);
  }

  return `rgba(${values.join(',')})`;
};

export const colorMixer = (hex1, weightage = 1, hex2 = colors.white) => {
  const rgb1 = getRGBFromHex(hex1);
  const rgb2 = getRGBFromHex(hex2);

  const hex1Weightage = weightage;
  const hex2Weightage = 1 - weightage;

  const effectiveRGB = rgb1.map((color, i) => {
    const weightedColor = color * hex1Weightage + rgb2[i] * hex2Weightage;
    const sanitisedColor = Math.max(
      0,
      Math.min(255, Math.floor(weightedColor))
    );
    return sanitisedColor;
  });

  return {
    color: `rgb(${effectiveRGB.join(',')})`,
    colorValues: effectiveRGB
  };
};
